import { render, staticRenderFns } from "./map-darwer.vue?vue&type=template&id=4770af82&scoped=true&"
import script from "./map-darwer.vue?vue&type=script&lang=ts&"
export * from "./map-darwer.vue?vue&type=script&lang=ts&"
import style0 from "./map-darwer.vue?vue&type=style&index=0&id=4770af82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4770af82",
  null
  
)

export default component.exports